import { render, staticRenderFns } from "./payment-card-default.vue?vue&type=template&id=3af44b00&"
import script from "./payment-card-default.vue?vue&type=script&lang=js&"
export * from "./payment-card-default.vue?vue&type=script&lang=js&"
import style0 from "./payment-card-default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports